import { render, staticRenderFns } from "./FormChairSaleDelete.vue?vue&type=template&id=099f69c2"
import script from "./FormChairSaleDelete.vue?vue&type=script&lang=js"
export * from "./FormChairSaleDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports